<template>
  <el-dialog
      :visible.sync="visible"
      title="修改发货厂"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-form-item label="发货工厂：" prop="type">
        <company v-model="dataForm.factoryId"></company>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t("confirm")
        }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  data() {
    return {
      ids:[],
      visible: false,
      dataForm: {},
    };
  },
  computed: {
    dataRule() {
      return {
        factoryId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
      };
    },
  },
  methods: {
    reset() {
      this.dataForm = {
        ids:this.ids,
        factoryId: ""
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.reset();
      });
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs["dataForm"].validate((valid) => {
            if (!valid) {
              return false;
            }
            let postForm = {
              ...this.dataForm,
              boxDetailId:this.dataForm.id
            };
            this.$http.post("/trade/boxformdetail/change/factory", postForm)
                .then(({ data: res }) => {
                  if (res.code !== 0) {
                    return this.$message.error(res.msg);
                  }
                  this.$message({
                    message: this.$t("prompt.success"),
                    type: "success",
                    duration: 500,
                    onClose: () => {
                      this.cancel();
                      this.$emit("refreshDataList");
                    },
                  });
                })
                .catch(() => {});
          });
        },
        1000,
        { leading: true, trailing: false }
    ),
    cancel() {
      this.visible = false;
    },
  },
};
</script>
